import { useTranslation } from "react-i18next";

import { RadioGroupControl } from "./RadioGroupControl";
import {
  CascadiaControlProps,
  withCascadiaControlProps,
} from "../wrappers/withCascadiaControlProps";

const YES_VALUE = "yes";
const NO_VALUE = "no";

function booleanToRadioValue(data: boolean | undefined): string | undefined {
  if (data === true) {
    return YES_VALUE;
  }
  if (data === false) {
    return NO_VALUE;
  }
  return undefined;
}

export function BooleanRadioGroupControl(props: CascadiaControlProps) {
  const { t } = useTranslation();

  return (
    <RadioGroupControl
      {...props}
      data={booleanToRadioValue(props.data)}
      setValue={(value: string) => props.setValue(value === YES_VALUE)}
      options={{
        ...props.options,
        card: false,
        orientation: "horizontal",
      }}
      items={[
        { label: t("Yes"), value: YES_VALUE },
        { label: t("No"), value: NO_VALUE },
      ]}
    />
  );
}

BooleanRadioGroupControl.displayName = "BooleanRadioGroupControl";

export const BooleanRadioGroupRenderer = withCascadiaControlProps(
  BooleanRadioGroupControl
);
